var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container-app"
  }, [_c('b-card', {
    staticClass: "card-header"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "2"
    }
  }), _c('b-col', {
    staticClass: "pdv-pesquisa",
    attrs: {
      "md": "8"
    }
  }, [_vm._t("formulario")], 2), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [!_vm.isMobile ? _c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip",
      value: !_vm.isFullScreen ? 'Entrar em Fullscreen' : 'Sair de Fullscreen',
      expression: "\n            !isFullScreen ? 'Entrar em Fullscreen' : 'Sair de Fullscreen'\n          "
    }],
    staticClass: "btn btn-secondary font-weight-bold",
    on: {
      "click": function click() {
        if (!_vm.isFullScreen) _vm.requestFullScreen();else _vm.closeFullscreen();
      }
    }
  }, [!_vm.isFullScreen ? _c('Fullscreen', {
    attrs: {
      "size": 20
    }
  }) : _c('Close', {
    attrs: {
      "size": 20
    }
  })], 1) : _vm._e()])], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };